import PropTypes from "prop-types";
import { useClientContext } from "../../ClientContext.jsx";
import { Card, STitle } from "../adminUtils.jsx";
import { RADIUS } from "../../shared/theme.js";

const BROKERS = [
  {
    key: "xp",
    label: "XP Investimentos",
    color: "#2563EB",
    bg: "#DBEAFE",
    note: "Posição Detalhada XLSX",
  },
  {
    key: "btg",
    label: "BTG Pactual",
    color: "#7C3AED",
    bg: "#EDE9FE",
    note: "Extrato CDB XLSX",
  },
  {
    key: "btg_pactual",
    label: "BTG (outro formato)",
    color: "#0891B2",
    bg: "#CFFAFE",
    note: "CSV · XLSX · OFX",
  },
  {
    key: "interwin",
    label: "Inter / Interwin",
    color: "#EA580C",
    bg: "#FEF3C7",
    note: "Relatório Rentabilidade PDF",
  },
  {
    key: "avenue",
    label: "Avenue Securities",
    color: "#16A34A",
    bg: "#DCFCE7",
    note: "Position Export CSV · PDF",
  },
];

const FILE_ACCEPT = ".csv,.xlsx,.xls,.ofx,.pdf,.zip";

export default function FileUploadSection({
  importState,
  drag,
  fileRef: _fileRef,
  setDrag,
  setImportBroker,
  importBroker: _importBroker,
  handleImportFile,
}) {
  const { T } = useClientContext();

  if (importState !== "idle" && importState !== "parsing") return null;

  return (
    <Card T={T} style={{ marginBottom: 20 }}>
      <STitle
        title="Importar Extrato — Alimentação de Snapshots"
        sub="Arraste o extrato de qualquer corretora para extrair posições e atualizar o dashboard do cliente"
        T={T}
      />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill,minmax(220px,1fr))",
          gap: 16,
          marginBottom: 16,
        }}
      >
        {BROKERS.map(({ key, label, color, bg, note }) => (
          <label
            key={key}
            onDragOver={(e) => {
              e.preventDefault();
              setDrag((d) => ({ ...d, [key]: true }));
            }}
            onDragLeave={() => setDrag((d) => ({ ...d, [key]: false }))}
            onDrop={(e) => {
              e.preventDefault();
              setDrag((d) => ({ ...d, [key]: false }));
              if (e.dataTransfer.files[0]) handleImportFile(e.dataTransfer.files[0], key);
            }}
            style={{
              border: `2px dashed ${drag[key] ? color : "#CBD5E1"}`,
              borderRadius: RADIUS.md,
              padding: "26px 16px",
              textAlign: "center",
              cursor: importState === "parsing" ? "wait" : "pointer",
              background: drag[key] ? bg : "transparent",
              transition: "all 0.2s",
              opacity: importState === "parsing" ? 0.6 : 1,
              userSelect: "none",
              display: "block",
            }}
          >
            {/* Native file input inside label — browser opens picker on click natively */}
            <input
              type="file"
              accept={FILE_ACCEPT}
              style={{ display: "none" }}
              disabled={importState === "parsing"}
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) {
                  setImportBroker(key);
                  handleImportFile(file, key);
                }
                e.target.value = "";
              }}
            />
            <div style={{ fontSize: 30, marginBottom: 8 }}>📂</div>
            <div style={{ fontSize: 13, fontWeight: 700, color, marginBottom: 3 }}>{label}</div>
            <div style={{ fontSize: 11, color: T.sub }}>{note}</div>
          </label>
        ))}
      </div>

      {importState === "parsing" && (
        <div style={{ textAlign: "center", padding: "18px 0", color: T.sub, fontSize: 13 }}>
          ⏳ Lendo arquivo e identificando posições…
        </div>
      )}
      <div
        style={{
          background: "#EFF6FF",
          border: "1px solid #BFDBFE",
          borderRadius: 10,
          padding: "12px 16px",
        }}
      >
        <p style={{ margin: 0, fontSize: 12, color: "#1E40AF" }}>
          <strong>Como funciona:</strong> O sistema lê o XLSX/CSV e extrai automaticamente posições,
          valores e rentabilidade para criar um snapshot mensal no banco. Você revisa os dados antes
          de salvar.
        </p>
      </div>
    </Card>
  );
}

FileUploadSection.propTypes = {
  importState: PropTypes.string.isRequired,
  drag: PropTypes.object.isRequired,
  fileRef: PropTypes.object,
  setDrag: PropTypes.func.isRequired,
  setImportBroker: PropTypes.func.isRequired,
  importBroker: PropTypes.string,
  handleImportFile: PropTypes.func.isRequired,
};
